/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Occupancy_HighInputs */

const fr_marker_occupancy_high = /** @type {(inputs: Marker_Occupancy_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forte affluence`)
};

const en_marker_occupancy_high = /** @type {(inputs: Marker_Occupancy_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High occupancy`)
};

/**
* | output |
* | --- |
* | "High occupancy" |
*
* @param {Marker_Occupancy_HighInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const marker_occupancy_high = /** @type {((inputs?: Marker_Occupancy_HighInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Occupancy_HighInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_occupancy_high(inputs)
	return en_marker_occupancy_high(inputs)
});